import z from 'zod'

export const PauseReasonSchema = z.object({
  id: z.string().uuid(),
  reason: z.string(),
  theme: z.string(),
  isActive: z.boolean(),
  slug: z.string(),
  legacyReasonId: z.number().int().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type PauseReason = z.infer<typeof PauseReasonSchema>
